/* global axios */
import ApiClient from './ApiClient';

class ScheduledMessagesAPI extends ApiClient {
  constructor() {
    super('conversations', {
      accountScoped: true,
    });
  }

  getUrl(conversationId) {
    return `${this.url}/${conversationId}/scheduled_messages`;
  }

  get(conversationId) {
    return axios.get(this.getUrl(conversationId));
  }

  create(conversationId, { content, scheduledAt }) {
    return axios.post(this.getUrl(conversationId), {
      scheduled_message: { content, scheduled_at: scheduledAt },
    });
  }

  update(conversationId, scheduledMessageId, { content, scheduledAt }) {
    return axios.patch(`${this.getUrl(conversationId)}/${scheduledMessageId}`, {
      scheduled_message: { content, scheduled_at: scheduledAt },
    });
  }

  delete(conversationId, scheduledMessageId) {
    return axios.delete(`${this.getUrl(conversationId)}/${scheduledMessageId}`);
  }
}

export default new ScheduledMessagesAPI();
